/**
 * @license
 * Copyright 2023 Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { __decorate } from "tslib";
import { CustomElement, attachLightTemplate } from '@tylertech/forge-core';
import { APP_BAR_MENU_BUTTON_CONSTANTS } from './app-bar-menu-button-constants';
import { IconButtonComponent } from '../../icon-button';
import { TooltipComponent } from '../../tooltip';
import { IconComponent, IconRegistry } from '../../icon';
import { tylIconMenu } from '@tylertech/tyler-icons/standard';
import { BaseComponent } from '../../core/base/base-component';
const template = '<template><forge-icon-button style=\"width: 48px; height: 48px; display: flex; justify-content: center; align-items: center;\"><button type=\"button\" aria-label=\"Toggle navigation menu\"><forge-icon name=\"menu\"></forge-icon></button><forge-tooltip delay=\"500\" position=\"bottom\">Menu</forge-tooltip></forge-icon-button></template>';
/**
 * The web component class behind the `<forge-app-bar-menu-button>` custom element.
 *
 * @tag forge-app-bar-menu-button
 */
let AppBarMenuButtonComponent = class AppBarMenuButtonComponent extends BaseComponent {
    constructor() {
        super();
        IconRegistry.define(tylIconMenu);
    }
    initializedCallback() {
        attachLightTemplate(this, template);
    }
};
AppBarMenuButtonComponent = __decorate([
    CustomElement({
        name: APP_BAR_MENU_BUTTON_CONSTANTS.elementName,
        dependencies: [
            IconButtonComponent,
            TooltipComponent,
            IconComponent
        ]
    })
], AppBarMenuButtonComponent);
export { AppBarMenuButtonComponent };
